import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function AuthorStory() {
  return <section className="py-24 bg-warm-alt" data-id="element-32">
      <div className="max-w-4xl mx-auto px-6" data-id="element-33">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-warm-accent/10" data-id="element-34">
          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-35">
            <div className="w-48 h-48 md:w-64 md:h-64 flex-shrink-0 rounded-full overflow-hidden border-4 border-warm-bg shadow-inner" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/u4EUaa4vEdAGZ2dxsjb7zk/D8DAC88F-2EE7-49E8-9441-05356A86A1C0.png" alt="Mujer frente al mar al amanecer recuperando su bienestar" className="w-full h-full object-cover" data-id="element-37" />
            </div>

            <div data-id="element-38">
              <h2 className="text-3xl font-heading text-warm-dark mb-6" data-id="element-39">
                Mi historia detrás de la guía
              </h2>
              <div className="space-y-4 text-warm-dark/80 leading-relaxed" data-id="element-40">
                <p data-id="element-41">
                  Hace unos años, mi vida se detuvo. Un diagnóstico de dos
                  hernias discales me dejó paralizada, no solo físicamente, sino
                  por el miedo. Me dijeron que tuviera cuidado con todo, y ese
                  cuidado se transformó en pánico al movimiento.
                </p>
                <p data-id="element-42">
                  Pasé meses buscando respuestas, sintiéndome incomprendida y
                  sola. Lloré de frustración al ver cómo mi calidad de vida
                  disminuía. Pero poco a poco, investigando, probando,
                  equivocándome y escuchando a mi cuerpo, empecé a encontrar
                  luz.
                </p>
                <p data-id="element-43">
                  Fueron 9 meses de un viaje transformador. Hoy vivo con mucha
                  más libertad y he recuperado mi calidad de vida. Escribí{' '}
                  <strong data-id="element-44">Espalda Libre</strong> porque es exactamente el
                  abrazo, la claridad y la guía que yo necesitaba
                  desesperadamente en mis peores días.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}